@if (showPopup) {
    <div #wrapper class="soft-popup-wrapper" [style.width.px]="width" [style.left.px]="styleLeft" [style.top.px]="styleTop" (document:mousedown)="close($event.target)">
        <div class="popup-header">
            <icon type="circle-info" />
            {{ title }}
            <div class="popup-close" (click)="close()"></div>
        </div>
        <div class="popup-body">
            <panel>
                <ng-content />
            </panel>
        </div>
    </div>
}
